/// <reference path='../_all.ts' />

module menuEditor {
  'use strict';

  export class Product {
    constructor(

      /**
      * Product ID
      */
      public Id: number,

      /**
      * Product Name
      */
      public Name: string,

      /**
      * Determines if element should be hidden
      */
      public IsHidden: boolean,

      /**
      * Determines if element has been modified
      */
      public Modified: boolean,

      /**
      * Modifier's E-Mail Address
      */
      public UserEmail: string,

    ) { }
  }
}